/**
 * Application configuration.
 */

export const config = {
  // Kratos public URL - proxied through Vite in dev, nginx in production
  kratosPublicUrl: import.meta.env.VITE_KRATOS_PUBLIC_URL || '/api/kratos',

  // Gateway URL for organization operations
  gatewayUrl: import.meta.env.VITE_GATEWAY_URL || '/api/gateway',

  // Return URL after successful auth
  defaultReturnUrl: import.meta.env.VITE_DEFAULT_RETURN_URL || '/settings',

  // App name for branding
  appName: import.meta.env.VITE_APP_NAME || 'OrbitalPassport',

  // Base domain for cross-service redirect inference
  baseDomain: import.meta.env.VITE_BASE_DOMAIN || 'epy.digital',
};
